<template>
  <wide-widget
    icon="pim"
    icon-type="svg"
    :loading="isLoading"
    :title="$t('dashboard.employee_online_offline')"
  >
    <div
      v-for="employee in employeeList"
      :key="employee"
      class="gsl-hrm-active-employee-card"
    >
      <div class="gsl-hrm-active-employee-card-profile-image">
        <img
          alt="profile picture"
          class="employee-image"
          :src="`../pim/viewPhoto/empNumber/${employee.empNumber}`"
        />
        <span
          class="status-dot"
          :class="employee.isOnline ? 'online' : 'offline'"
        ></span>
      </div>
      <div class="gsl-hrm-active-employee-card-details">
        <oxd-text tag="p" class="gsl-hrm-active-employee-card-emp-name">
          {{ employee.empName }}
        </oxd-text>
      </div>
      <div class="gsl-hrm-active-employee-card-activities">
        {{ employee.lastActivity }}
      </div>
    </div>
  </wide-widget>
</template>
<script>
import WideWidget from '@/orangehrmDashboardPlugin/components/WideWidget.vue';
import {APIService} from '@/core/util/services/api.service';
import useEmployeeNameTranslate from '@/core/util/composable/useEmployeeNameTranslate';

export default {
  name: 'ActiveEmployeeListWidget',
  components: {
    'wide-widget': WideWidget,
  },
  setup() {
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/attendance/employees/active',
    );
    const {$tEmpName} = useEmployeeNameTranslate();

    return {
      http,
      tEmpName: $tEmpName,
    };
  },
  data() {
    return {
      employeeList: [],
      isLoading: false,
      activeEmployeeCount: 0,
    };
  },
  beforeMount() {
    this.isLoading = true;
    this.http
      .getAll()
      .then((response) => {
        const {data, meta} = response.data;
        this.employeeList = data.map((item) => {
          const {employee, punchIn, punchOut, state} = item;
          const isOnline = state.id === 'PUNCHED IN';
          let lastActivity = '';

          if (isOnline && punchIn?.userDate && punchIn?.userTime) {
            lastActivity = `Punched in at ${punchIn.userDate} ${punchIn.userTime}`;
          } else if (punchOut?.userDate && punchOut?.userTime) {
            lastActivity = `Last punched out at ${punchOut.userDate} ${punchOut.userTime}`;
          } else {
            lastActivity = 'No recent activity';
          }
          return {
            empNumber: employee.empNumber,
            empName: this.tEmpName(employee, {
              includeMiddle: false,
              excludePastEmpTag: false,
            }),
            isOnline,
            lastActivity,
          };
        });
        this.activeEmployeeCount = meta?.total;
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
};
</script>
<style src="./active-employee-list-widget.scss" lang="scss" scoped></style>
